<template>
    <div class="columns is-mobile is-centered has-background-primary p-2">
        <h1 class="title is-4 has-text-white">Gestionale LMC</h1>
    </div>
    <div class="columns is-mobile is-centered">
        <p><br><br>Utente: &nbsp;&nbsp;&nbsp; {{ credenzialiUtente.nome }} {{ credenzialiUtente.cognome }} 
        <br><br>Accesso: &nbsp;&nbsp;&nbsp; {{ credenzialiUtente.autorizzazione }}
        <br><br>Versione: &nbsp;&nbsp;&nbsp; {{idVersione}}
        <br><br>Versione più recente: &nbsp;&nbsp;&nbsp; {{ultimaVersione.id}}
        <br><br>Credits: &nbsp;&nbsp;&nbsp; ing. Marco Cauda
        </p>
    </div>
</template>

<script setup>
  import { credenzialiUtente } from '../code/firebase';
  import { idVersione, ultimaVersione } from '../code/utilita'

</script>